module.exports = __webpack_public_path__ + "static/sf-ui-semibold-224afb2e366bc2abe52f9a5630de4e45.ttf";